import React, { useState, useEffect } from "react";
import Layout from "../../components/layouts/Layout";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    isSuccess,
    toastErrorMessages,
    toastSuccessMessages,
    catchAsync,
    getRecords,
    phoneRegExp,
    formateDateString,
    formateDate,
    calculateNextYearEndDate,
    calculateHolidayHours,
    updateRecords,
    convertDateFormat,
} from "../../helper/helper";
import {
    CustomOption,
    // updateRecords,
    handleReload,
    calculateTimeDifference,
    handleSetIdFormikFormData,
    handleTimeChangeToNumeric,
    useShiftEffect,
    days,
    weeksOptions,
    getFormDataProps,
    GenerateScheduleFormData,
    handleFormUpdate,
    handleCheckboxChange,
    useCheckedEffect,
    uploadFile,
    staffDesignationOptions,
    vehicleTypeOptions,
    userInputFields,
    userNokInputFields,
    workLoadFields,
    sprStatus,
    sprResult,
    handleSelectChange,
    updateDesignationFields,
    passwordRegex,
    updateStaffValidationSchema,
    staffRoleOptions,
} from "../../helper/helperJsx";
import {
    GET_STAFF_PERMISSIONS,
    UPDATE_STAFF_PERMISSIONS
} from "../../env";


function RoleBasedPermissions() {
    const [permissionItems, setPermissionItems] = useState([]);
    const [allRoles, setAllRoles] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);

    const permissionListQuery = {
        sortProperty: "createdAt",
        sortOrder: -1,
        offset: 0,
        query: {
            critarion: {
                active: true,
                permissionName: {
                    $nin: ["Super Admin"],
                },
            },
        },
    };

    const fetchAllPermissionRecords = catchAsync(async () => {
        const response = await getRecords(GET_STAFF_PERMISSIONS, permissionListQuery);
        const staffPermissions = response?.data?.permissions?.filter(
            (item) => item.permissionName !== "Super Admin"
        );
        const formattedData = staffPermissions?.map((item) => ({
            value: item._id,
            label: item.permissionName,
        }));
        setPermissionItems(formattedData);
        setAllRoles(staffPermissions);
    });

    useEffect(() => {
        fetchAllPermissionRecords();
    }, []);

    // Formik
    const formik = useFormik({
        initialValues: {
            permissionid: "",
            permissionName: "",
            permissions: [],
            taskAllocationPermissions: [],
            level: "",
        },
        enableReinitialize: true, // allow updating values when role changes
        onSubmit: async (values) => {
            try {
                const response = await updateRecords(UPDATE_STAFF_PERMISSIONS, values);
                console.log("🚀 ~ RoleBasedPermissions ~ values:", values)
                if (response?.status === "Success") {
                    toast.success("success", response?.message);

                } else {
                    toast.error("error", response?.message);
                }
                fetchAllPermissionRecords();
            } catch (error) {
                toast.error("error", "Something went wrong!");
            }
        },
    });

    // Handle role change
    const handleRoleChange = (e) => {
        const roleId = e.target.value;
        const role = allRoles.find((r) => r._id === roleId);

        setSelectedRole(role || null);

        if (role) {
            formik.setValues({
                permissionid: role._id,
                permissionName: role.permissionName,
                permissions: role.permissions || [],
                taskAllocationPermissions: role.taskAllocationPermissions || [],
                level: role.level,
            });
        }
    };

    // Handle checkbox change for permissions
    const handleCheckboxChange = (section, index, key) => {
        const updated = [...formik.values[section]];
        updated[index] = { ...updated[index], [key]: !updated[index][key] };
        formik.setFieldValue(section, updated);
    };

    return (
        <Layout pageTitleText="Role Based Permissions">
            <header className="headerContainerSearchAction">
                <div className="actionButtons">
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={formik.handleSubmit}
                        type="button"
                    >
                        Update Permissions
                    </button>
                </div>
                <div className="selectStaffRole">
                    <select
                        id="permissionSelect"
                        className="form-select"
                        onChange={handleRoleChange}
                    >
                        <option value="">-- Select --</option>
                        {permissionItems.map((perm) => (
                            <option key={perm.value} value={perm.value}>
                                {perm.label}
                            </option>
                        ))}
                    </select>
                </div>
            </header>

            <div className="scheduleBlocks careplanOptions">
                <div className="row">
                    <div className="col-md-12">
                        {selectedRole && (
                            <>
                                {/* Permissions Table */}
                                <h3>Permissions</h3>
                                <div className="table-reponsive">
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th className="text-center">Create</th>
                                                <th className="text-center">Update</th>
                                                <th className="text-center">View</th>
                                                <th className="text-center">Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formik.values.permissions?.map((perm, idx) => (
                                                <tr key={perm._id}>
                                                    <td>{perm.title}</td>
                                                    {["create", "update", "view", "delete"].map((key) => (
                                                        <td key={key}>
                                                            <div className="form-check d-flex justify-content-center">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`perm-${idx}-${key}`}
                                                                    checked={perm[key]}
                                                                    onChange={() =>
                                                                        handleCheckboxChange("permissions", idx, key)
                                                                    }
                                                                />
                                                            </div>
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <hr />

                                {/* Task Allocation Permissions Table */}
                                <h3>Task Allocation Permissions</h3>
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th className="text-center">isAdminReviewRequired</th>
                                            <th className="text-center">Accept</th>
                                            <th className="text-center">Reject</th>
                                            <th className="text-center">View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formik.values.taskAllocationPermissions?.map(
                                            (task, idx) => (
                                                <tr key={task._id}>
                                                    <td>{task.title}</td>
                                                    {["isAdminReviewRequired", "accept", "reject", "view"].map(
                                                        (key) => (
                                                            <td key={key}>
                                                                <div className="form-check d-flex justify-content-center">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`task-${idx}-${key}`}
                                                                        checked={task[key]}
                                                                        onChange={() =>
                                                                            handleCheckboxChange(
                                                                                "taskAllocationPermissions",
                                                                                idx,
                                                                                key
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>
                                                        )
                                                    )}
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <ToastContainer autoClose={1000} />
        </Layout>
    );
}

export default RoleBasedPermissions;

